export default __webpack_public_path__ + "eceeafd9b8cc2707d423befbe8cd1873.png";